import React from "react";

import styles from "./pageNotFound.module.css";

const PageNotFound = () => {
  /* Page Not Found (404) is a public page shown when a user is trying to access a URL that does not exist on the website. */

  return (
    <div className={styles.main}>
      <h2 className={styles.h2}>
        Oops! Looks like you're lost in translation.
      </h2>
    </div>
  );
};

export default PageNotFound;
